<div class="app-content" [class.full-width-dash]="!showSideBadge">
  <div class="landing-page-flex" [class.no-side-badge]="!showSideBadge">
    <div class="padding-left-0" *ngIf="showSideBadge">
      <ng-container>
        <div class="landing-side1 invisible-scroll">
          <div class="hpanel contact-panel">
            <div class="panel-body border-radius-top-left-right-6" style="padding: 0px !important;">
              <app-user-badge></app-user-badge>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
    <div class="padding-left-0 padding-right-0 width-100per">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>

<div class="chatPopup">
  <button (click)="chatbottom()" class="btn btn-info btn-circle" type="button"> <ng-icon name="tablerMessage"></ng-icon> Chat <span
      class="badge noti-badge noti-chat-icon" *ngIf="totalMsgCount>0"> {{totalMsgCount}}</span></button>
  <app-message-widget *ngIf="messagemodelflag" (closeMessageModel)="closeMessage($event)"
    [messageDataPass]="messageData"> </app-message-widget>
</div>


<app-notifier [title]="notificationTitle" [message]="notificationContent" [buttonName]="'Add Backup Email'"
  [executeShow]="showSecondaryAlert"></app-notifier>
